<template>
  <el-dialog
      :visible.sync="visible"
      title="销售发票冲减"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        :rules="dataRule"
        label-position="left"
        v-if="dataForm&&dataForm.product"
    >
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="8">
          <el-form-item prop="code" label="出口发票号：">
            {{dataForm.receiptCode}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="operateDate" label="装船日期：">
            {{dataForm.shipDate}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="sellerId" label="外销合同号：" >
            {{dataForm.agreementCode}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="remark" label="品番号：" >
            {{dataForm.product.code}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="skuCode" label="SKU：" >
            {{dataForm.product.skuCode}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="name" label="品名：" >
            {{dataForm.product.name}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="color" label="颜色：" >
            {{dataForm.product.color}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="size" label="规格：" >
            {{dataForm.product.size}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="totalCount" label="发货数量：" >
            {{dataForm.totalCount}}
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="newBoxCode" label="冲减出口发票号：" >
            <el-input v-model="dataForm.newBoxCode" size="mini" style="width: 200px;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="newCount" label="冲减数量：" >
            <el-input v-model="dataForm.newCount" size="mini" style="width: 200px;"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import PayDetailSelDialog from '@/views/modules/erp/pay/PayDetailSelDialog.vue'
import BigNumber from 'bignumber.js'
import { isNumber, moneyValidator } from '@/utils/validate'
import debounce from 'lodash/debounce'

export default {
  name:'edit-count-dialog',
  components: {  },
  data () {
    return {
      dataForm: {},
      visible: false,
      dataRule: {
        newBoxCode: [
          { required: true, message: '请填写冲减出口发票号', trigger: 'change' },
        ],
        newCount: [
          { required: true, message: '请填写冲减数量', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (!isNumber(value)) {
                callback(new Error('请输入正确的数字'))
                return
              }
              if(value>this.dataForm.totalCount){
                callback(new Error('冲减数量不能大于发货数量'))
                return
              }
              callback()
            }, trigger: 'change'
          },
        ],
      }
    }
  },
  computed: {

  },
  methods: {
    init (data) {
      this.$set(this,'dataForm',data)
      this.$set(this.dataForm,'newCount',data.totalCount)
      this.$set(this.dataForm,'newBoxCode','')
      this.visible = true
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            let postForm = {
              boxDetailId:this.dataForm.id,
              newBoxCode:this.dataForm.newBoxCode,
              reduceCount:this.dataForm.newCount
            }
            if (this.saving) {
              return
            }
            this.saving = true
            this.$api2.post('/erp/box/detail/reduce', postForm).then(res => {
              this.saving = false
              this.$emit('complete')
              this.$c.success(this.$t('prompt.success')).then(() => {
                this.visible=false
              })
            }).catch(() => {
              this.saving = false
            })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  }
}
</script>

<style scoped>

</style>
